<!--  -->
<template>
  <div class="main_w">
    <div class="v1">
      <span class="v1_t1">第一期</span>
      <span class="v1_t2">2022年 09月 29 日至2022年10 月 29 日</span>
    </div>
    <div class="v2">本期主题：IT工程师的日常10分钟</div>
    <div class="v3"></div>
    <div class="v4">
      <div class="v4_1" @click="toDetail">活动详情</div>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    toDetail() {
      this.$router.push({
        path: "/20220929-next.html",
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.main_w {
  width: 7.5rem;
  margin: 0 auto;
  min-height: 100vh;
  background: url("~@/assets/images/active/active20220929/01.png") no-repeat;
  background-size: cover;
  overflow: hidden;
}
.v1 {
  width: 5.57rem;
  height: 0.63rem;
  background: url("~@/assets/images/active/active20220929/04.png") no-repeat;
  background-size: cover;
  line-height: 0.66rem;
  margin: 3rem auto 0;
  text-align: center;
  font-size: 0;
  .v1_t2 {
    font-size: 0.24rem;
    color: #575757;
    font-weight: bold;
  }
  .v1_t1 {
    font-size: 0.24rem;
    color: #575757;
  }
}
.v2 {
  font-size: 0.31rem;
  color: #fff;
  font-weight: bolder;
  text-align: center;
  margin: 0.2rem auto 0;
}
.v3 {
  width: 6.7rem;
  height: 1.24rem;
  background: url("~@/assets/images/active/active20220929/07.png") no-repeat;
  background-size: cover;
  margin: 0.3rem auto 0;
}
.v4 {
  width: 6.94rem;
  height: 10.03rem;
  background: url("~@/assets/images/active/active20220929/06.png") no-repeat;
  background-size: cover;
  margin: 0.2rem auto 0.5rem;
  position: relative;
  .v4_1 {
    width: 6.31rem;
    height: 0.9rem;
    background: #fd7c32;
    border-radius: 0.25rem;
    color: #fff;
    line-height: 0.9rem;
    text-align: center;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    bottom: 0.2rem;
    font-size: 0.3rem;
  }
}
</style>